import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center ma-2"},[_c(VSnackbar,{attrs:{"absolute":"","centered":"","top":"","timeout":3000,"color":_vm.sesh.snack.color},model:{value:(_vm.sesh.snack.display),callback:function ($$v) {_vm.$set(_vm.sesh.snack, "display", $$v)},expression:"sesh.snack.display"}},[_vm._v(" "+_vm._s(_vm.sesh.snack.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }